import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import HeroHeading from '../global/Hero/HeroHeading';
import P from '../global/typography/P';
import Btn from '../global/Button/ClearButton';
import Play from '../global/icons/Play';
import VideoOverlay from '../global/VideoOverlay';
import BaseInnerWrapper from '../global/InnerWrapper';

const Content = styled.div`
  margin-left: 10%;
  width: calc(100% - 10%);

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    margin: 0;
    width: 100%;
  }
`;

export const InnerWrapper = styled(BaseInnerWrapper)`
  align-items: center;
  display: flex;
  position: relative;
  padding-top: 80px;
  z-index: 1;

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    padding-top: 30px;
  }
`;

const Wrapper = styled.div`
  height: 550px;
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.55);
`;

const HomeHeroHeading = styled(HeroHeading)`
  width: 70%;

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    max-width: 100%;
    width: 100%;
  }
`;

const Text = styled(P)`
  color: ${p => p.theme.color.tertiary};
  width: 42%;

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    width: 70%;
  }
  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    width: 90%;
  }

  @media (max-width: ${p => p.theme.deviceWidth.mobilePhone}) {
    width: 100%;
  }
`;

const Opacity = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`;

const PlayContainer = styled.div`
  margin-left: 8px;
  height: 13px;
  width: 13px;

  display: grid;
`;

const PlayBg = styled.div`
  background-color: ${p => p.theme.color.headerSecondaryDarkened};
  border-radius: 100%;
  grid-column: 1;
  grid-row: 1;
  height: 11px;
  margin: 1px;
  width: 11px;
`;

const Button = styled(Btn)`
  margin-top: 42px;
  width: 157px;
  height: 48px;
  padding-left: 0;

  svg {
    height: 13px;
    width: 13px;
    fill: ${p => p.theme.color.headerSecondary};
    transition: 0.5s;
    background-color: ${props => props.theme.color.linkPrimary};

    grid-column: 1;
    grid-row: 1;

    /* undo settings from base button */
    visibility: visible;
    margin-left: 0;
  }

  &:hover {
    svg {
      fill: ${p => p.theme.color.headerSecondaryDarkened};
      stroke-width: 0;

      polygon {
        stroke-width: 0%;
        fill: ${props => props.theme.color.linkPrimaryDarkened};
      }
      background-color: transparent;
    }

    &:after {
      content: '';
    }
  }

  @media (max-width: ${p => p.theme.deviceWidth.largePhone}) {
    display: flex;
  }

  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    max-width: 142px;
  }
`;

const Video = styled.video`
  position: absolute;
  z-index: 1;
  height: 550px;
  width: 100%;
  object-fit: cover;
`;

const HomeHero = () => {
  const [showVideo, setShowVideo] = useState(false);

  function toggleVideo() {
    setShowVideo(showVideo => !showVideo);
  }

  return (
    <Fragment>
      <Wrapper>
        <Video
          autoPlay
          disablePictureInPicture
          loop
          muted
          playsinline
          poster="/home/poster.jpg"
        >
          {/* TODO: Update this video */}
          <source src="/noble/loch_noble.mp4" type="video/mp4" />
        </Video>
        <Opacity />
        <InnerWrapper>
          <Content>
            <HomeHeroHeading>More Hot Water, Faster</HomeHeroHeading>
            <Text>What you want and need from a combi boiler</Text>
            <Button onClick={toggleVideo} hideCaret>
              Play Video
              <PlayContainer>
                <PlayBg />
                <Play />
              </PlayContainer>
            </Button>
          </Content>
        </InnerWrapper>
      </Wrapper>
      <VideoOverlay
        id="5d8mEDeTVdg"
        show={showVideo}
        toggleOverlay={toggleVideo}
      />
    </Fragment>
  );
};

export default HomeHero;
